import React from "react";
import { Link } from "react-router-dom";
import { Box, Button, Typography, Grid } from "@material-ui/core";
import EmailIcon from "@material-ui/icons/Email";
import useStyles from "./CallToAction.Styles";


function CallToAction() {
    const classes = useStyles();

    return (
        <Box className={classes.ctaBox}>
            <Typography variant="h5" className={classes.ctaText}>
                Ready to schedule your service? Contact us today!
            </Typography>
            <Grid container spacing={4} alignItems="center" justifyContent="center">
                <Grid item>
                    <img
                        src="/insurance-seal.webp" // Replace with your image path
                        alt="Chinook Water Testing is Licensed and Insured"
                        className={classes.ctaImage}
                        loading="lazy"
                        data-ratio='407 / 247'
                    />
                </Grid>
                <Grid item>
                    <Button
                        variant="contained"
                        color="primary"
                        size="medium"
                        component={Link}
                        to="/contact"
                        className={classes.ctaButton}
                        startIcon={<EmailIcon />}
                    >
                        Contact Us
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
}

export default CallToAction;
